import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Skeleton } from '@mui/material';

import SectionWrapper from '../../../../message-response/components/section-wrapper/SectionWrapper';
import CompareChart from '../compare-chart/CompareChart';

function CompareSection({ selectedAudience, isFiltersApplied }) {
  const { t } = useTranslation('resonance');

  const filterColumns = useSelector((state) => state.resonance.filterColumns);
  const isBackgroundDataLoading = useSelector((state) => state.resonance.isBackgroundDataLoading);
  const selectedAudienceFilter = filterColumns.find(({ header }) => header === selectedAudience);

  return (
    <SectionWrapper>
      {!selectedAudienceFilter || isBackgroundDataLoading ? (
        <Skeleton animation='wave' variant='rounded' height={350} />
      ) : (
        <CompareChart selectedAudienceFilter={selectedAudienceFilter} isFiltersApplied={isFiltersApplied} />
      )}
    </SectionWrapper>
  );
}

export default CompareSection;
